import React from 'react';
import toast from 'react-hot-toast';

const instructions = [
    { title: "Internet Banking", desc: 'Access your bank\'s website via "Payments" and enter the digital line' },
    { title: "Electronic Booth", desc: 'Select "Payments," "Ticket" and enter the digital line' },
    { title: "Bank Branch", desc: 'Take the printed ticket to a bank branch or lottery house' },
    { title: "Bank App", desc: 'Use the camera to scan the digital line or enter it manually' },
];

const BoletoPaymentPage = ({ data, closeModal, selectedMethod }) => {
    return (
        selectedMethod === "mercado" ? (
            <>
                <div>
                    <div style={{ background: "#2F2F2F", borderRadius: "8px", width: "400px" }} className="container py-2">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="shadow-lg border-0">

                                    {/* Header */}
                                    <div style={{ borderRadius: "10px" }} className="text-white text-center py-3">
                                        <div className='d-flex justify-content-between px-2 align-items-center'>
                                            <h2 className="h4 mb-1">Your ticket was successfully generated</h2>
                                            <span onClick={closeModal}
                                                className="text-white cursor-pointer fs-3 fw-bold">
                                                ×
                                            </span>
                                        </div>
                                        <p className="mb-0 opacity-75 small">Pay until expiration date</p>
                                    </div>

                                    {/* Payment Summary */}
                                    <div style={{ background: "#2F2F2F" }} className="p-3">
                                        <div className="row g-3 text-center">
                                            <div className="col-md-4">
                                                <div className="payment-date text-light">
                                                    R$ {parseFloat(data?.transaction_amount).toFixed(2)}
                                                </div>
                                                <small className="text-light text-uppercase fw-bold">Amount</small>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="payment-date text-light">
                                                    {new Date(data?.date_of_expiration).toLocaleDateString('pt-BR')}
                                                </div>
                                                <small className="text-light text-uppercase fw-bold">Due Date</small>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="payment-id text-light">{data?.payment_method_id}</div>
                                                <small className="text-light text-uppercase fw-bold">Payment ID</small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Expiration Warning */}
                                    <div className="mx-3 mt-3">
                                        <div style={{ background: "#ff8000", marginBottom: "10px", borderRadius: "10px" }} className="text-center border-2 py-2">
                                            <p className="mb-1 fw-semibold small">Time until expiration:</p>
                                            <span className="text-gray fw-bold fs-6">
                                                {(() => {
                                                    const diffMs = new Date(data?.date_of_expiration) - new Date();
                                                    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                                                    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                                    return `${days} days, ${hours} hours`;
                                                })()}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Bank Details */}
                                    <div className="mx-3 mb-3">
                                        <div style={{ background: "lightgrey" }} className="border-2">
                                            <div className="rounded p-1">
                                                <div className="rounded row g-2 small">
                                                    <div className="col-md-6">
                                                        <div className="border-bottom pb-1 mb-1">
                                                            <strong className="text-dark">Beneficiary</strong>
                                                            <div className="text-muted small mb-3">{data?.payment_method_id}</div>
                                                        </div>
                                                        <div>
                                                            <strong className="text-dark">Our Number</strong>
                                                            <div className="text-muted small">{data?.transaction_details?.payment_method_reference_id}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="border-bottom pb-1 mb-1">
                                                            <strong className="text-dark">Payer</strong>
                                                            <div className="text-muted small">
                                                                {data?.payer?.first_name + " " + data?.payer?.last_name}
                                                            </div>
                                                            <div className="text-muted small">CPF: {data?.payer?.identification?.number}</div>
                                                        </div>
                                                        <div>
                                                            <strong className="text-dark">Due Date</strong>
                                                            <div className="text-muted small">
                                                                {new Date(data?.date_of_expiration).toLocaleDateString('pt-BR')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Digital Line */}
                                                <div className="rounded p-2 mt-2 small">
                                                    <strong className="d-block mb-1">Digital Line:</strong>
                                                    <div className="d-flex flex-column flex-md-row gap-2 align-items-stretch">
                                                        <div className="flex-grow-1 digital-line white-space-normal">
                                                            {data?.transaction_details?.digitable_line}
                                                        </div>
                                                        <button
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(data?.transaction_details?.digitable_line);
                                                                toast.success("Copied to clipboard");
                                                            }}
                                                            className="btn deposit-btn btn-sm d-flex align-items-center justify-content-center"
                                                            style={{ minWidth: '90px' }}>
                                                            <i className="bi bi-clipboard me-1"></i>
                                                            Copy
                                                        </button>
                                                    </div>
                                                    <small className="text-muted d-block mt-1">
                                                        Use this line for payment via internet banking or mobile apps.
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="mx-3 mb-3 d-flex gap-2">
                                        <button
                                            className="btn deposit-btn btn-sm flex-grow-1 d-flex align-items-center justify-content-center gap-1"
                                            onClick={() => window.open(data?.transaction_details?.external_resource_url, '_blank')}
                                        >
                                            <i className="bi bi-printer me-1"></i> Print Ticket
                                        </button>
                                        <button
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                link.href = data?.transaction_details?.external_resource_url;
                                                link.download = 'ticket.pdf';
                                                link.target = '_blank';
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}
                                            className="btn deposit-btn btn-sm flex-grow-1 d-flex align-items-center justify-content-center gap-1">
                                            <i className="bi bi-file-earmark-pdf"></i> Download PDF
                                        </button>
                                    </div>

                                    {/* PDF Notice */}
                                    <div className="mx-3 text-light mb-3">
                                        <div className="border-2 small">
                                            <i className="bi bi-check-circle-fill me-1"></i>
                                            <strong>PDF Available</strong><br />
                                            Click "Download PDF Ticket" to download or print.
                                        </div>
                                    </div>

                                    {/* Payment Instructions */}
                                    <div className="mx-3 mb-3">
                                        <div className="text-light p-2 small">
                                            <h6 className="mb-2">How to Pay:</h6>
                                            {instructions.map((i, idx) => (
                                                <div key={idx} className="d-flex align-items-start mb-1 gap-2">
                                                    <span style={{ background: "#ff8000" }} className="badge text-light rounded-circle">{idx + 1}</span>
                                                    <div>
                                                        <strong>{i.title}</strong>: {i.desc}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Important Information */}
                                    <div className="mx-3 mb-3">
                                        <div className="text-light border-2 small">
                                            <ul className="mb-0 ps-3">
                                                <li>The ticket expires 3 days after generation</li>
                                                <li>After expiration, it cannot be paid</li>
                                                <li>Payment may take up to 2 business days</li>
                                                <li>Keep the payment receipt</li>
                                            </ul>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="text-light text-center p-2">
                                        <button className="btn btn-secondary btn-sm mb-1" onClick={closeModal}>
                                            <i className="bi bi-arrow-left me-1"></i> Return to Checkout
                                        </button>
                                        <p className="mb-0 small">Problems with the ticket? <a href="#" className="fw-bold">Contact Support</a></p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <>
            <div>
                    <div style={{ background: "#2F2F2F", borderRadius: "8px", width: "400px" }} className="container py-2">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="shadow-lg border-0">

                                    {/* Header */}
                                    <div style={{ borderRadius: "10px" }} className="text-white text-center py-3">
                                        <div className='d-flex justify-content-between px-2 align-items-center'>
                                            <h2 className="h4 mb-1">Your ticket was successfully generated</h2>
                                            <span onClick={closeModal}
                                                className="text-white cursor-pointer fs-3 fw-bold">
                                                ×
                                            </span>
                                        </div>
                                        <p className="mb-0 opacity-75 small">Pay until expiration date</p>
                                    </div>

                                    {/* Payment Summary */}
                                    <div style={{ background: "#2F2F2F" }} className="p-3">
                                        <div className="row g-3 text-center">
                                            <div className="col-md-4">
                                                <div className="payment-date text-light">
                                                    R$ {parseFloat(data?.items[0]?.unit_amount/100).toFixed(2)}
                                                </div>
                                                <small className="text-light text-uppercase fw-bold">Amount</small>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="payment-date text-light">
                                                    {new Date(data?.created_at).toLocaleDateString('pt-BR')}
                                                </div>
                                                <small className="text-light text-uppercase fw-bold">Due Date</small>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="payment-id text-light">{data?.id}</div>
                                                <small className="text-light text-uppercase fw-bold">Payment ID</small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Expiration Warning */}
                                    {/* <div className="mx-3 mt-3">
                                        <div style={{ background: "#ff8000", marginBottom: "10px", borderRadius: "10px" }} className="text-center border-2 py-2">
                                            <p className="mb-1 fw-semibold small">Time until expiration:</p>
                                            <span className="text-gray fw-bold fs-6">
                                                {(() => {
                                                    const diffMs = new Date(data?.date_of_expiration) - new Date();
                                                    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                                                    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                                    return `${days} days, ${hours} hours`;
                                                })()}
                                            </span>
                                        </div>
                                    </div> */}

                                    {/* Bank Details */}
                                    <div className="mx-3 mb-3">
                                        <div style={{ background: "lightgrey" }} className="border-2">
                                            <div className="rounded p-1">
                                                <div className="rounded row g-2 small">
                                                    <div className="col-md-6">
                                                        <div className="border-bottom pb-1 mb-1">
                                                            <strong className="text-dark">Beneficiary</strong>
                                                            <div className="text-muted small mb-3">{data?.customer?.name}</div>
                                                        </div>
                                                        {/* <div>
                                                            <strong className="text-dark">Our Number</strong>
                                                            <div className="text-muted small">{data?.customer?.tax_id}</div>
                                                        </div> */}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="border-bottom pb-1 mb-1">
                                                            <strong className="text-dark">Payer</strong>
                                                            <div className="text-muted small">
                                                                {data?.customer?.name}
                                                            </div>
                                                            {/* <div className="text-muted small">CPF: {data?.customer?.identification?.number}</div> */}
                                                        </div>
                                                        {/* <div>
                                                            <strong className="text-dark">Due Date</strong>
                                                            <div className="text-muted small">
                                                                {new Date(data?.date_of_expiration).toLocaleDateString('pt-BR')}
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>

                                                {/* Digital Line */}
                                                <div className="rounded p-2 mt-2 small">
                                                    <strong className="d-block mb-1">Digital Line:</strong>
                                                    <div className="d-flex flex-column flex-md-row gap-2 align-items-stretch">
                                                        <div className="flex-grow-1 digital-line white-space-normal">
                                                            {data?.charges[0]?.payment_method?.boleto?.barcode}
                                                        </div>
                                                        <button
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(data?.charges[0]?.payment_method?.boleto?.barcode);
                                                                toast.success("Copied to clipboard");
                                                            }}
                                                            className="btn deposit-btn btn-sm d-flex align-items-center justify-content-center"
                                                            style={{ minWidth: '90px' }}>
                                                            <i className="bi bi-clipboard me-1"></i>
                                                            Copy
                                                        </button>
                                                    </div>
                                                    <small className="text-muted d-block mt-1">
                                                        Use this line for payment via internet banking or mobile apps.
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    {/* <div className="mx-3 mb-3 d-flex gap-2">
                                        <button
                                            className="btn deposit-btn btn-sm flex-grow-1 d-flex align-items-center justify-content-center gap-1"
                                            onClick={() => window.open(data?.transaction_details?.external_resource_url, '_blank')}
                                        >
                                            <i className="bi bi-printer me-1"></i> Print Ticket
                                        </button>
                                        <button
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                link.href = data?.transaction_details?.external_resource_url;
                                                link.download = 'ticket.pdf';
                                                link.target = '_blank';
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}
                                            className="btn deposit-btn btn-sm flex-grow-1 d-flex align-items-center justify-content-center gap-1">
                                            <i className="bi bi-file-earmark-pdf"></i> Download PDF
                                        </button>
                                    </div> */}

                                    {/* PDF Notice */}
                                    {/* <div className="mx-3 text-light mb-3">
                                        <div className="border-2 small">
                                            <i className="bi bi-check-circle-fill me-1"></i>
                                            <strong>PDF Available</strong><br />
                                            Click "Download PDF Ticket" to download or print.
                                        </div>
                                    </div> */}

                                    {/* Payment Instructions */}
                                    <div className="mx-3 mb-3">
                                        <div className="text-light p-2 small">
                                            <h6 className="mb-2">How to Pay:</h6>
                                            {instructions.map((i, idx) => (
                                                <div key={idx} className="d-flex align-items-start mb-1 gap-2">
                                                    <span style={{ background: "#ff8000" }} className="badge text-light rounded-circle">{idx + 1}</span>
                                                    <div>
                                                        <strong>{i.title}</strong>: {i.desc}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Important Information */}
                                    <div className="mx-3 mb-3">
                                        <div className="text-light border-2 small">
                                            <ul className="mb-0 ps-3">
                                                <li>The ticket expires 3 days after generation</li>
                                                <li>After expiration, it cannot be paid</li>
                                                <li>Payment may take up to 2 business days</li>
                                                <li>Keep the payment receipt</li>
                                            </ul>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="text-light text-center p-2">
                                        <button className="btn btn-secondary btn-sm mb-1" onClick={closeModal}>
                                            <i className="bi bi-arrow-left me-1"></i> Return to Checkout
                                        </button>
                                        <p className="mb-0 small">Problems with the ticket? <a href="#" className="fw-bold">Contact Support</a></p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </>
        )
    );
};

export default BoletoPaymentPage;
